// src/stone/icons/SignalContactless.tsx
import { jsx } from "react/jsx-runtime";
var SignalContactless = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M3.828 16.48c-.2 0-.399-.1-.599-.2-.399-.3-.499-1-.2-1.399.6-.899 1-1.897 1-2.996s-.3-2.097-1-2.996c-.299-.3-.199-.899.2-1.198.4-.3 1.099-.2 1.398.2.899 1.198 1.398 2.696 1.398 4.094 0 1.498-.5 2.896-1.398 4.095-.2.3-.499.4-.799.4M8.321 18.876c-.2 0-.4 0-.5-.2-.498-.3-.598-.898-.299-1.398.999-1.598 1.498-3.395 1.498-5.293 0-1.897-.5-3.695-1.498-5.293-.399-.5-.2-1.099.2-1.398.5-.3 1.098-.2 1.398.3 1.198 1.897 1.897 4.094 1.897 6.391s-.6 4.494-1.897 6.392c-.2.3-.5.499-.799.499M12.714 21.173c-.2 0-.4 0-.5-.1-.499-.3-.598-.899-.299-1.398 1.398-2.297 2.097-4.994 2.097-7.69s-.7-5.293-2.097-7.59c-.3-.5-.2-1.099.3-1.398.499-.3 1.098-.1 1.397.3 1.598 2.596 2.396 5.592 2.396 8.688s-.798 6.092-2.396 8.689c-.2.3-.599.5-.898.5M17.206 23.47c-.2 0-.3 0-.499-.1-.499-.3-.599-.899-.4-1.398 1.798-2.996 2.696-6.492 2.696-9.987s-.898-6.99-2.695-9.987c-.3-.5-.1-1.099.4-1.398.498-.3 1.097-.1 1.397.4C20.002 4.294 21 8.09 21 11.984c0 3.795-.998 7.59-2.895 10.986-.3.3-.6.499-.899.499" })
  }
);
var SignalContactless_default = SignalContactless;

export {
  SignalContactless,
  SignalContactless_default
};
